<script setup>
import {onBeforeMount, reactive, ref} from 'vue'
import {State, clone} from '@/paks/vu-app'

const {modelValue: display} = defineProps({modelValue: Object})

const emit = defineEmits(['update:modelValue'])

const page = reactive({
    basis: 'Standard',
    displays: [],
    existing: false,
    expressionType: 'Responsive',
    prior: null,
})

onBeforeMount(() => {
    page.existing = display.name != null
    page.prior = clone(display)
    page.displays = State.app.fullDisplay.displays
    setExpressionType()
})

async function changePageSet() {
    let standard = clone(State.app.standardDisplay.displays[0])
    let views
    if (page.basis == 'Minimal') {
        views = selectViews(null, standard.views, ['/login', '/logout', '/designer', '/claim'])
        views[0].component = 'Page'
    } else {
        views = clone(display.views)
    }
    standard.views = views
    emit('update:modelValue', standard)
}

//  Select views based on the allow list which contains top level paths
function selectViews(parentPath, views, allow, result = []) {
    for (let view of views) {
        let path
        if (parentPath == '/') {
            path = '/' + view.path
        } else if (parentPath) {
            path = parentPath + '/' + view.path
        } else {
            path = view.path
        }
        if (path == '/') {
            result.push(view)
        } else if (allow.find((p) => path.indexOf(p) >= 0)) {
            result.push(view)
        }
        if (view.views) {
            view.views = selectViews(path, view.views, allow, [])
        }
    }
    return result.length > 0 ? result : null
}

function changeType() {
    let type = page.expressionType
    if (type == 'Responsive') {
        display.expression = ''
        display.features.nav.sidebarHide = false
    } else if (type == 'Mobile') {
        display.expression = 'width < 640'
        display.features.nav.sidebarHide = true
    } else if (type == 'Tablet') {
        display.expression = '640 <= width && width < 1024'
        display.features.nav.sidebarHide = false
    } else if (type == 'Desktop') {
        display.expression = 'width >= 1024'
        display.features.nav.sidebarHide = false
    } else if (type == 'Custom') {
        display.expression = ''
        display.features.nav.sidebarHide = false
    }
}

function setExpressionType() {
    let exp = display.expression
    if (exp == '') {
        page.expressionType = 'Responsive'
    } else if (exp == 'width < 640') {
        page.expressionType = 'Mobile'
    } else if (exp == '640 <= width && width < 1024') {
        page.expressionType = 'Tablet'
    } else if (exp == 'width >= 1024') {
        page.expressionType = 'Desktop'
    } else {
        page.expressionType = 'Custom'
    }
}
</script>

<template>
    <div class="display-match-edit">
        <vu-input
            v-model="display.name"
            label="Display Name"
            name="name"
            placeholder="Enter display name"
            type="text"
            class="mb-2" />

        <vu-input
            v-if="!page.existing"
            v-model="page.basis"
            label="Page Set"
            type="radio"
            :items="['Minimal', 'Standard']"
            @update:modelValue="changePageSet" />

        <vu-input
            v-model="page.expressionType"
            label="Expression Type"
            type="radio"
            :items="['Responsive', 'Mobile', 'Desktop', 'Custom']"
            @update:modelValue="changeType" />

        <vu-input
            v-if="page.expressionType != 'Responsive'"
            :disabled="page.expressionType == 'Custom' ? false : true"
            v-model="display.expression"
            class="mb-2"
            label="Display Matching Expression"
            placeholder="Expression with 'width', 'agent', 'height', 'language'"
            name="expression"
            type="text" />
    </div>
</template>
